import EmblaCarousel from 'embla-carousel'

export default (function () {
    const carousels = document.querySelectorAll('[data-carousel]')
    carousels.forEach((carousel) => initCarousel(carousel))
})

const initCarousel = (carousel) => {
    const wrapper = carousel.querySelector('.wrapper')
    const slides = carousel.querySelectorAll('.slide-container > *')
    if (slides.length === 0) return

    const options = {
        align: 'start',
    }

    const carouselApi = EmblaCarousel(wrapper, options)

    carousel.querySelector('.slide-container').style.marginLeft = 'calc(var(--slide-spacing) * -1)'

    slides.forEach((slide) => {
        slide.classList.add(`pl-[var(--slide-spacing)]`)
        slide.classList.add(`flex-[0_0_var(--slide-size)]`)
        slide.classList.add(`lg:flex-[0_0_var(--slide-size-large)]`)
    })

    const hasNavigation = carousel.querySelector('[data-carousel-previous-button]')
    if (hasNavigation) addButtonNavigation(carousel, carouselApi)

    const dotsContainer = carousel.querySelector('[data-carousel-dots-navigation]')

    if (dotsContainer) addDotNavigation(carouselApi, dotsContainer)

    const carouselId = carousel.getAttribute('data-carousel')
    if (carouselId !== '') addSplitLayout(carouselApi, carouselId)

    const thumbnails = carousel.querySelectorAll('[data-thumbnail-index]')
    if (thumbnails.length !== 0) addThumbnailNavigation(carouselApi, thumbnails)
}

const addButtonNavigation = (carousel, api) => {
    const prevButton = carousel.querySelector('[data-carousel-previous-button]')
    const nextButton = carousel.querySelector('[data-carousel-next-button]')

    if (!prevButton || !nextButton) return

    addTogglePrevNextButtonsActive(api, prevButton, nextButton)
    addPrevNextButtonsClickHandlers(api, prevButton, nextButton)
}

const addTogglePrevNextButtonsActive = (api, prevButton, nextButton) => {
    const togglePrevNextButtonsState = () => {
        if (api.canScrollPrev()) prevButton.removeAttribute('disabled')
        else prevButton.setAttribute('disabled', 'disabled')

        if (api.canScrollNext()) nextButton.removeAttribute('disabled')
        else nextButton.setAttribute('disabled', 'disabled')
    }

    api.on('select', togglePrevNextButtonsState).on('init', togglePrevNextButtonsState).on('reInit', togglePrevNextButtonsState)

    return () => {
        prevButton.removeAttribute('disabled')
        nextButton.removeAttribute('disabled')
    }
}

const addPrevNextButtonsClickHandlers = (api, prevButton, nextButton) => {
    const scrollPrev = () => {
        api.scrollPrev()
    }
    const scrollNext = () => {
        api.scrollNext()
    }
    prevButton.addEventListener('click', scrollPrev, false)
    nextButton.addEventListener('click', scrollNext, false)

    const removeTogglePrevNextButtonsActive = addTogglePrevNextButtonsActive(api, prevButton, nextButton)

    return () => {
        removeTogglePrevNextButtonsActive()
        prevButton.removeEventListener('click', scrollPrev, false)
        nextButton.removeEventListener('click', scrollNext, false)
    }
}

const addDotNavigation = (api, dotsContainer) => {
    let dotElements = []

    const addDotBtnsWithClickHandlers = () => {
        dotsContainer.innerHTML = api
        .scrollSnapList()
        .map(() => `<li data-dot class='group'><button class='button--carousel-dot' type='button'></button></li>`)
        .join('')

        const scrollTo = (index) => {
            api.scrollTo(index)
        }

        const labelsSlide = document.querySelector('[data-labels]')
        const labelSlide = labelsSlide.getAttribute('data-label-slide')
        const labelOf = labelsSlide.getAttribute('data-label-of')

        dotElements = Array.from(dotsContainer.querySelectorAll('[data-dot]'))
        dotElements.forEach((dot, index) => {
            dot.setAttribute('aria-label', `${labelSlide} ${index + 1} ${labelOf} ${dotElements.length}`)
            dot.addEventListener('click', () => scrollTo(index), false)
        })
    }

    const toggleDotBtnsActive = () => {
        const previous = api.previousScrollSnap()
        const selected = api.selectedScrollSnap()
        dotElements[previous]?.classList.remove('active')
        dotElements[selected]?.classList.add('active')

        dotElements.forEach((dot) => dot.setAttribute('aria-current', 'false'))
        dotElements[selected].setAttribute('aria-current', 'true')
    }

    api.on('init', addDotBtnsWithClickHandlers).on('reInit', addDotBtnsWithClickHandlers).on('init', toggleDotBtnsActive).on('reInit', toggleDotBtnsActive).on('select', toggleDotBtnsActive)

    return () => {
        dotsContainer.innerHTML = ''
    }
}

const addSplitLayout = (api, type) => {
    const contentToSplit = document.querySelectorAll(`[data-carousel-id='${type}']`)

    const toggleContentActive = () => {
        const activeIndex = api.selectedScrollSnap()

        contentToSplit.forEach((content) => {
            const slides = content.querySelectorAll(':scope > *')
            slides.forEach((slide) => slide.classList.add('opacity-0'))
            slides[activeIndex].classList.remove('opacity-0')
        })
    }

    api.on('select', toggleContentActive)
    api.on('init', toggleContentActive)
}

const addThumbnailNavigation = (api, thumbnails) => {
    const goToIndex = (index) => {
        api.scrollTo(Number(index))
    }

    thumbnails.forEach((thumbnail) => {
        const index = thumbnail.getAttribute('data-thumbnail-index')
        thumbnail.addEventListener('click', () => goToIndex(index), false)

        return () => {
            thumbnail.removeEventListener('click', () => goToIndex(index), false)
        }
    })
}
